<section *ngIf="show" class="mt-4 text-muted text-center">App version: {{ appVersion }} / {{ bffVersion$ | async }}</section>
